var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReferral = function SvgReferral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#22D683",
    d: "M70 35c0 19.33-15.67 35-35 35S0 54.33 0 35 15.67 0 35 0s35 15.67 35 35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M34.958 26.569c1.51-2.175 3.732-3.996 6.403-4.458 2.646-.457 5.52.5 7.559 2.2 3.212 2.682 4.988 8.097 2.186 11.69-1.435 1.84-14.76 16.1-16.148 18.007-1.186-1.624-14.195-15.688-15.81-17.628-2.66-3.201-1.863-7.786.7-10.81 1.925-2.268 4.966-3.68 7.955-3.558 2.998.122 5.575 2.118 7.155 4.557"
  }))));
};
export default SvgReferral;